/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopMentorReport from './_PopMentorReport';
function MentorReport() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7},
    {title: '미작성', type: 'red', value: 8},
    {title: '내 보고서', value: 9}
  ];
  const [modalMentorReport, setModalMentorReport] = useState(false);
  return (
    <main className="com_container p_mentor_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_15">멘토 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalMentorReport(true)} className="com_btn orange s btn_plus">
              멘토 보고서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    첫수업 예정일
                  </th>
                  <th>등록자 (멘토)</th>
                  <th>학생명</th>
                  <th>교사</th>
                  <th>과목</th>
                  <th>담임</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date">2022.08.25</td>
                  <td className="td_date">2022.08.25</td>
                  <td>
                    <button className="btn_link">가멘토102</button>
                  </td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td>수학</td>
                  <td>
                    <button className="btn_link">가담임102</button>
                  </td>
                  <td>
                    <button className="btn_link red">미작성</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button className="btn_link">가멘토102</button>
                      </td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td>수학</td>
                      <td>
                        <button className="btn_link">가담임102</button>
                      </td>
                      <td>
                        <button className="btn_link blue">2023, 05, 10</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                    <p className="txt">
                      {' '}
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">첫 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사 / 담임</span>
                  <span className="cont">
                    <button className="btn_link">김교사302</button> /<button className="btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
              </div>
              <div className="board_item">
                <div className="cont">
                  <p className="name">학습계획</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">과제물</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">학습목표</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
                <hr className="com_divider" />
                <div className="cont">
                  <p className="name">취약단원</p>
                  <ul className="list">
                    <li className="item">1. 기출수능 분석을 통한 문제푸는 방법 확인</li>
                    <li className="item">2. EBS 출제 가능한 문학 작품 정리</li>
                    <li className="item">3. 비문학 구조, 문학 중요 개념 등 정리</li>
                  </ul>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">수고 하셨습니다.</div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopMentorReport open={modalMentorReport} close={() => setModalMentorReport(false)} />
    </main>
  );
}

export default MentorReport;
